import React, { useCallback, useEffect, useState, Fragment } from "react";
import FormValidators from "../FormValidators/index";
import NonHostedLinks from "./NonHostedLinks";
import { Field, reduxForm, Label } from "redux-form";
import { UpwardReduxCheckbox } from "../ui";
import axios from "axios";

const CoReg = (props) => {

    const [formData, setFormData] = useState("JC");
    const [formData2, setFormData2] = useState(props.jobState+"JD");
    const [formDataCombined, setFormDataCombined] = useState("");
    const [checked, setChecked] = useState(true);
    const [checked2, setChecked2] = useState(true);
    
    const toggleChecked = () => setChecked(value => !value);
    const toggleChecked2 = () => setChecked2(value => !value);

    const handleSubmit = e => {

        props.showLoad();

        axios.all([
            axios.get(process.env['REACT_APP_API_URL'] + "/search/internalPost2.fsn?OID=12818&new_flow=1&coregistration_domain=" + formDataCombined + "&" + props.queryString),
        ])
        .then(responseArr => {
            window.newrelic.addPageAction('coreg', {registration: 'success'});
            props.hideLoad();
            //props.goResults2(); use this skip resume step and go to results
            if(props.qs && props.qs.resume && props.qs.resume === "n"){
                props.goResults2();
            } else {
                props.onFormSubmit('uploadResume');
            }
        }, (error) => {
            window.newrelic.addPageAction('coreg', {registration: 'failure'});
            props.hideLoad();
            console.log(error);
            //props.goResults2();
            if(props.qs && props.qs.resume && props.qs.resume === "n"){
                props.goResults2();
            } else {
                props.onFormSubmit('uploadResume');
            }
        });

    }

    useEffect(() => {
        if(checked){
            setFormData("jobcase.com");
        } else if(!checked) {
            setFormData("");
        }
        if(checked2){
            setFormData2(props.jobState+"jobdepartment.com");
        } else if (!checked2) {
            setFormData2("");
        }
        if(checked && checked2){
            setFormDataCombined(formData+","+formData2);
        } else if(checked && !checked2){
            setFormDataCombined(formData);
        } else if(!checked && checked2){
            setFormDataCombined(formData2);
        } else {
            setFormDataCombined("empty");
        }
    }, [checked, checked2, formData, formData2, props.jobState]);

    return (
        <Fragment>
            <form onSubmit={props.handleSubmit(handleSubmit)} autoComplete="off">
                <label htmlFor="coreg_domain">
                <input 
                    component={UpwardReduxCheckbox}
                    type="checkbox"
                    name="coreg_domain"
                    checked={checked}
                    id="domain1"
                    onChange={toggleChecked}
                />Join the Jobcase community to connect with hiring managers and get hired faster.</label>
                <label htmlFor="coreg_domain2">
                <input 
                    component={UpwardReduxCheckbox}
                    type="checkbox"
                    id="domain2"
                    name="coreg_domain2"
                    checked={checked2}
                    onChange={toggleChecked2}
                />Get the latest local job from {props.jobState.charAt(0).toUpperCase() + props.jobState.slice(1)} Job Department straight to your inbox.</label>
                <div className={"loading " + ( props.loading ? 'in' : '')}><div className="spinner"><div className="bounce1"></div><div className="bounce2"></div><div className="bounce3"></div></div></div>
                <div className="text-center"><button type="submit" className="btn btnSmall fullwidth btn-block">Continue</button></div>
            </form>
            {(((!props.hostedType.toLowerCase().toLowerCase() === "hosted" && !props.hostedType.toLowerCase() === "hosted_plus") ||  (props.hostedType.toLowerCase() === "")) && (window.skipVal === "yes" || window.skipVal === "x"))
            &&
            <NonHostedLinks {...props} />
            }
        </Fragment>
    )

}


export default reduxForm({
    form: 'CoReg',
  })(CoReg);
